import React from 'react';
import { CTAButton } from './CTAButton';
import { TrustRow } from './TrustRow';
import { BOX_IMG, CHECKOUT_URL } from './constants';
export function Hero() {
  return <section className="pt-6 pb-6 px-4 sm:px-6 bg-white text-center" data-id="element-75" data-mp="ei1vfm5pk2xy">
      <div className="inline-block px-3 py-1 rounded-full bg-gold/15 border border-gold/40 text-petrol font-heading font-bold text-[10px] sm:text-xs uppercase tracking-widest mb-3" data-id="element-76" data-mp="9lbkfd8rfxje">
        Sistema Completo 6-in-1
      </div>

      <h1 className="text-2xl sm:text-4xl font-heading font-extrabold text-petrol leading-tight mb-2" data-id="element-77" data-mp="1274nlnxyxe6p">
        Il Sistema Completo di Pianificazione per Allenatori di Fitness Senior
      </h1>

      <p className="text-sm sm:text-lg text-warmgray font-semibold leading-snug mb-4 max-w-2xl mx-auto" data-id="element-78" data-mp="sd4aaysj92mw">
        Risparmia ore ogni settimana preparando lezioni, programmi e percorsi di
        allenamento per adulti senior, senza dover creare ogni sessione da zero.
      </p>

      <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block cursor-pointer mb-4" data-id="element-79" data-mp="3814aznapvuna">
        <img src={BOX_IMG} alt="SENIOR FITNESS COACH PRO — Sistema Completo 6-in-1" className="w-full h-auto object-contain max-w-[280px] sm:max-w-md mx-auto hover:scale-[1.02] transition-transform duration-300 drop-shadow-xl" data-id="element-80" data-mp="3o85cdefo0765" />
      </a>

      <div className="mb-3 max-w-lg mx-auto" data-id="element-81" data-mp="30i18d5yke5em">
        <CTAButton data-id="element-82" data-mp="30gzteqefgyrm">🚀 SÌ! VOGLIO SENIOR FITNESS COACH PRO™ ORA</CTAButton>
      </div>

      <TrustRow data-id="element-83" data-mp="358zpg7rdn7ix" />
    </section>;
}